var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { attrs: { id: "monitor-multiple-signs" } },
    _vm._l(_vm.data, function(item, index) {
      return _c("div", { key: index, staticClass: "signs-table" }, [
        _c("div", { staticClass: "signs-table__key" }, [
          _c("b", [_vm._v(_vm._s(item["idx"]))])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "signs-table__value" },
          _vm._l(item["sign_icons"], function(sign, sign_index) {
            return _c("span", { key: sign_index, staticClass: "icon__box" }, [
              sign !== "-"
                ? _c("span", { domProps: { innerHTML: _vm._s(sign) } })
                : _c("span", [_vm._v(_vm._s(sign))])
            ])
          }),
          0
        )
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }